<template>
  <QImage2 :relativePath="relativePath" :size="size" :fallbackIcon="icon" :articleNumber="articleNumber"
    :openPickerOnClick="editable" :editable="editable" @File="file => $emit('File', file)">
  </QImage2>
</template>


<script>
import QImage2 from "@/components/QImage2.vue";
import TimeTypeConstants from "@/helpers/Constants/TimeTypeConstants.js";

export default {
  name: "ArticleImage",
  props: {
    size: Number,
    relativePath: String,
    editable: Boolean,
    timeType: Number,
    articleNumber: String,
  },
  components: {
    QImage2,
  },
  mixins: [],

  data() {
    return {
    };
  },

  methods: {},

  computed: {
    icon() {
      var key = TimeTypeConstants.values[this.timeType];
      var i = TimeTypeConstants[key]?.icon || '$article';
      //console.log("Icon for timeType", this.timeType, key, i);
      return i;
    }
  },

  watch: {},
};
</script>